exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\r\n  text-align: center;\r\n}\r\n\r\n.imgtemp {\r\n\t width:200; height:200\r\n}\r\n\r\n.Group{\r\n\twidth:200; height:200;\r\n}", ""]);
